<script setup lang="ts">
import { Alert } from '@youcan/celeste';

defineProps<{ email: string }>();
</script>

<template>
  <Alert
    :dismissable="false"
    size="lg"
    state="warning"
    variant="stroke"
  >
    <template #title>
      {{ $t('notice.email-update-pending.title') }}
    </template>
    <template #description>
      {{ $t('note.email-update-pending.content', { email }) }}
    </template>
  </Alert>
</template>
